export default __webpack_public_path__ + "static/media/13.fea5688c.png";